/**
 * JQuery
 */

import $ from "jquery";

window.jQuery = $;
window.$ = $;

require("../lib/youmax-pro.min.js");
require("../lib/youmax-pro.min.css");

/**
 * Bootstrap
 */

import {
  Accordion, // Accordions
  // Alert,       // Dismissible alerts
  Button, // Toggle button states
  // Carousel,    // Slideshow component
  Collapse, // Accordion-like collapsing elements
  // Dropdown,    // Dropdown menus
  Modal, // Popup modals
  // Offcanvas,   // Offcanvas sidebars
  // Popover,     // Pop-up content on hover/click (requires @popperjs/core)
  // ScrollSpy,   // Auto-updating navigation based on scroll position
  // Tab,         // Tabs and pills navigation
  // Toast,       // Small pop-up notifications
  // Tooltip      // Tooltips for elements (requires @popperjs/core)
} from "bootstrap";

window.Collapse = Collapse;

/**
 * Swiper
 */

import Swiper from "swiper/bundle";
import "swiper/css/bundle";

window.Swiper = Swiper;

/* Fancybox */

// import { Fancybox } from "@fancyapps/ui";
// import "@fancyapps/ui/dist/fancybox.css";

/* Gsap */

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;

// var Isotope = require('isotope-layout');

/**
 * Utils
 */

import massimo from "./js/utils/massimo";
massimo();

import scrollTop from "./js/utils/scrollTop";
scrollTop();

/**
 * Layout
 */

import navbar from "./js/layout/navbar";
navbar();

import footer from "./js/layout/footer";
footer();

import sidebar from "./js/layout/sidebar";
sidebar();

import archive from "./js/layout/archive";
archive();

import search from "./js/layout/search";
search();

/**
 * Blocks
 */

import blockSliderHero from "./js/blocks/blockSliderHero";
blockSliderHero();

import blockSliderNews from "./js/blocks/blockSliderNews";
blockSliderNews();

import blockSliderZoom from "./js/blocks/blockSliderZoom";
blockSliderZoom();

import blockGridYouTube from "./js/blocks/blockGridYouTube";
blockGridYouTube();

import blockAccordion from "./js/blocks/blockAccordion.js";
blockAccordion();
